import { FlexRow } from '@editor/components/utilities/layouts';
import { P2 } from '@repo/ui/components/Typography';
import { BREAKPOINTS } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const BannerContainer = styled(FlexRow)`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-grow: 1;
  background-color: ${themeStyle.varBlueLight};
  border-radius: ${themeStyle.radiusMedium};
  container-type: inline-size;
  container-name: credits-limit-banner;
`;

export const TextContainer = styled(FlexRow)`
  gap: 8px;
  flex-wrap: wrap;

  @container credits-limit-banner (min-width: ${BREAKPOINTS.largeTabletMin}px) {
    gap: 12px;
  }
`;

export const CreditLimitText = styled(P2)`
  line-height: 20px;
`;

export const LimitTextContainer = styled(FlexRow)`
  gap: 6px;
  align-items: center;

  ::after {
    content: none;
  }

  @container credits-limit-banner (min-width: ${BREAKPOINTS.largeTabletMin}px) {
    border-right: 1px solid ${themeStyle.varInkMain};
    padding-right: 12px;
  }
`;
